<template>
  <div>
    <div v-if="showStopsInfo" class="transform absolute bg-white bottom-0 w-full ease-in-out transition-all duration-300 z-10 block h-80 overflow-y-scroll scrollbar">
      <div class="bg-gray-light">
        <div v-for="groupedTrip in groupedTrips" v-bind:key="groupedTrip.stop.stopId">
          <div v-if="groupedTrip.trips !== null" class="border-gray-300 border-t border-b" v-bind:style="{ borderColor: getBorderColor(groupedTrip) }">
            <div class="border-link border-l-8">
              <h3 class="px-4 py-1 bg-gray-200 border-gray-300 border-b-2 font-bold">{{ groupedTrip.stop.stopName }}</h3>
              <div v-for="trip in groupedTrip.trips" v-bind:key="trip.tripId" class="px-4 py-2 border-gray-300 border-b text-body-light">
                <div @click="openDetail( trip.tripId , trip.stopSequence, groupedTrip)">
                  <p class="text-sm">{{ getCorpName(groupedTrip.stop.corpName) }}</p>
                  <h4 class="mb-1 text-lg font-bold">{{ trip.routeName }}</h4>
                  <p class="flex text-sm leading-tight">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.8" viewBox="0 0 16 12.8" class="mt-0.5 mr-1 text-link">
                      <path d="M13.071,0V4.267H4.362V8.533h8.709V12.8l7.291-6.464Z" transform="translate(-4.362)" />
                    </svg>
                    {{ trip.headsign }}
                  </p>
                  <div class="mt-2 py-1 flex justify-center items-center rounded text-center text-white" :class="getArrivalColor(trip)">
                    {{ getArrivalText(trip) }}
                    <span v-if="trip.delay !== null && trip.delay > 0" class="ml-1.5 px-1.5 bg-white text-sm" style="color:#db3131">約{{ Math.ceil(trip.delay / 60) }}分遅れ</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isBusLocationTrips(groupedTrips)">
          <h4 class="bg-white pl-4 pt-2 text-lg font-bold">本日の運行は終了しました</h4>
        </div>
      </div>
    </div>
    <div v-if="showStopTime" class="absolute bg-white bottom-0 w-full">
      <div class="text-white" :class="getPassingColor(stopTime.trip)">
        <h3 class="px-4 py-1 border-b border-white">{{ stopTime.stopName }}</h3>
        <div class="py-2 text-center">
          <p class="text-xl font-semibold">{{ getArrivalText(stopTime.trip) }}</p>
          <div v-if="stopTime.trip.delay !== null && stopTime.trip.delay > 0" class="mx-auto my-2 py-1 w-60 border border-white text-sm">
            約{{ Math.ceil(stopTime.trip.delay / 60) }}分遅れ
          </div>
          <div v-else class="mx-auto my-2 py-1 w-60 border border-white text-sm">
            遅れなし
          </div>
          <p v-if="stopTime.trip.timestamp !== null" class="text-sm">最終更新：{{ getLastUpdate(stopTime.trip.timestamp) }}</p>
        </div>
        <div class="px-4 py-2 bg-white text-body-light">
          <h4 class="mb-1.5 font-bold">{{ getCorpName(stopTime.corpName) }}：{{ stopTime.trip.routeName }}</h4>
          <div v-if="stopTime.vehicle !== null" class="text-sm">
            <p v-if="stopTime.vehicle.prevStopName !== null">1つ前に通過：{{ getStop(stopTime.vehicle.prevStopName).stopName }}</p>
            <p v-if="stopTime.vehicle.nextStopName !== null">次に停車：{{ getStop(stopTime.vehicle.nextStopName).stopName }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  data () {
    return {
      showStopsInfo: false,
      showStopTime: false,
      locationPath: null,
      locationParams: {},
      locationMarker: null,
      selectedBusstopMarker: null,
      infoWindow: null
    }
  },
  methods: {
    openStopInfo: function () {
      this.$store.dispatch('loading/beginLoading')
      if (this.selectedBusStops.length > 0) {
        var stopIds = []
        for (var i = 0; i < this.selectedBusStops.length; i++) {
          stopIds.push(this.selectedBusStops[i].stopId)
        }
        this.$store.dispatch('busLocation/getGroupedTrips', stopIds.join(":"))
          .then(() => {
            this.showStopsInfo = true
          })
          .finally(() => {
            this.$store.dispatch('loading/endLoading')
          })
      }
    },
    getArrivalText: function (trip) {
      var t = moment(trip.estimateDepTime)
      if (trip.delay !== null) {
        t.add(trip.delay, 's')
      }
      const now = moment()
      if (t.diff(now, 'minute') < 0) {
        return String(now.diff(t, 'minute')) + '分前に出発しました'
      } else if (trip.status === 1) {
        return '出発しました'
      } else if (t.diff(now, 'minute') <= 5) {
        return 'まもなく到着します'
      } else if(t.diff(now, 'minute') <= 30){
        return 'あと約' + String(t.diff(now, 'minute')) + '分で到着します'
      } else{
        return t.format('HH') + ':' + t.format('mm') + ' 到着予定'
      }
    },
    getArrivalColor: function (trip) {
      var t = moment(trip.estimateDepTime)
      if (trip.delay !== null) {
        t.add(trip.delay, 's')
      }
      const now = moment()
      if (t.diff(now, 'minute') < 0 || trip.status === 1) {
        return 'bg-bus_status-gray'
      } else if (t.diff(now, 'minute') <= 3) {
        return 'bg-bus_status-red'
      } else if (t.diff(now, 'minute') <= 10) {
        return 'bg-bus_status-yellow'
      } else {
        return 'bg-bus_status-green'
      }
    },
    getPassingColor: function (trip) {
      if (trip.status === 1) {
        return 'bg-bus_status-gray'
      } else {
        return 'bg-bus_status-green'
      }
    },
    openDetail: function (tripId, stopSequence, groupedTrip) {
      this.setBusstopMarker(groupedTrip)
      this.locationParams = {
        tripId: tripId,
        stopSequence: stopSequence
      }
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('busLocation/getShapes', tripId)
        .then(() => {
          if (this.locationPath !== null) {
            this.locationPath.setMap(null)
          }
          const shapes = this.$store.getters['busLocation/getShapes']
          var path = [];
          for (var i = 0; i < shapes.length; i++) {
              path.push(new this.google.maps.LatLng(shapes[i].lat, shapes[i].lon));
          }
          this.locationPath = new this.google.maps.Polyline({
              path: path
          });
          this.locationPath.setMap(this.map);
          this.locationPath.set("strokeColor", "#a9a9a9");
          this.$store.dispatch('busLocation/getStopTime', this.locationParams)
            .then(() => {
              this.showStopsInfo = false
              this.showStopTime = true
              setTimeout(this.updateLocation, 10000)
            })
            .finally(() => {
              this.$store.dispatch('loading/endLoading')
            })
        })
    },
    setBusstopMarker: function (groupedTrip) {
      const busstop = this.selectedBusStops.find((s) => s.stopId == groupedTrip.stop.stopId)
      if (this.selectedBusstopMarker === null) {
        this.selectedBusstopMarker = new this.google.maps.Marker({
            position: {
                lat: busstop.lat, lng: busstop.lon
            },
            title: busstop.stopId,
            map: this.map,
            icon: {
              url: this.selectedBusIconPath(),
              scaledSize: new this.google.maps.Size(36, 36)
            },
            zIndex: 1100
        })
        this.google.maps.event.addListener(this.selectedBusstopMarker, "click", () => {
          this.infoWindow.open(this.map, this.selectedBusstopMarker)
        })
      } else {
        this.selectedBusstopMarker.setPosition({ lat: busstop.lat, lng: busstop.lon })
        this.selectedBusstopMarker.setVisible(true)
      }
      this.$store.dispatch('map/updateCenter', { lat: busstop.lat, lng: busstop.lon })
      this.infoWindow = new this.google.maps.InfoWindow({ content: '<div class="font-bold">'+ busstop.stopName+'</div>' })
      this.infoWindow.open(this.map, this.selectedBusstopMarker)
    },
    selectedBusIconPath() {
      return require('@/assets/images/mapmarker/busstop_select.png')
    },
    updateLocation: function () {
      if (this.isOpen && this.showStopTime) {
        this.$store.dispatch('busLocation/getStopTime', this.locationParams)
          .then(() => {
            setTimeout(this.updateLocation, 10000)
          })
      }
    },
    setBusMarker: function () {
      const location = {lat: this.stopTime.vehicle.lat, lng: this.stopTime.vehicle.lon}
      if (this.locationMarker === null) {
        this.locationMarker = new this.google.maps.Marker({
          position: location,
          title: "バス位置情報",
          map: this.map,
          icon: {
            url: require('@/assets/images/mapmarker/location.png'),
            scaledSize: new this.google.maps.Size(28, 28),
            anchor: new this.google.maps.Point(18, 18)
          },
          zIndex: 50,
          visible: true
        })
      } else {
        this.locationMarker.setPosition(location)
        this.locationMarker.setVisible(true)
      }
      this.$store.dispatch('map/updateCenter', location)
    },
    getStop: function (stopId) {
      const stops = this.$store.getters['busLocation/getStops']
      return stops.find((stop) => stop.stopId == stopId)
    },
    getLastUpdate: function (timestamp) {
      const t = moment.unix(timestamp)
      return parseInt(t.format('HH'), 10) + "時" + t.format('mm') + "分" + t.format('ss') + "秒"
    },
    getCorpName: function (corpName) {
      return corpName.replace("株式会社","")
    },
    getBorderColor: function (groupedTrip) {
      if (groupedTrip.trips !== null && groupedTrip.trips.length > 0 && groupedTrip.trips[0].routeColor !== undefined) {
        return "#" + String(groupedTrip.trips[0].routeColor)
      } else {
        return "rgba(209, 213, 219)"
      }
    },
    isBusLocationTrips: function (groupedTrips) {
      for (let i = 0; i < groupedTrips.length; i++) {
        if (groupedTrips[i].trips !== null) {
          return true
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isOpen: 'busLocation/getIsOpen',
      selectedBusStops: 'busLocation/getSelectedStops',
      groupedTrips: 'busLocation/getGroupedTrips',
      stopTime: 'busLocation/getStopTime',
      map: 'googleMap/getMap'
    }),
    google: gmapApi
  },
  watch: {
    isOpen: function (val) {
      if (val) {
        this.openStopInfo()
      } else {
        this.showStopsInfo = false
        this.showStopTime = false
        if (this.locationPath !== null) {
          this.locationPath.setMap(null)
        }
        if (this.selectedBusstopMarker !== null) {
          this.selectedBusstopMarker.setVisible(false)
        }
        if (this.infoWindow !== null) {
          this.infoWindow.close()
        }
        this.$store.dispatch('busLocation/resetStopTime')
      }
    },
    stopTime: function () {
      if (this.stopTime === null) {
        if (this.locationMarker !== null) {
          this.locationMarker.setVisible(false)
        }
      } else if (this.stopTime.vehicle !== null) {
        this.setBusMarker()
      }
    }
  }
}
</script>
